@if (invoice(); as invoice) {
  @if (invoice.status === 'PAID') {
    @switch (invoice.userPlan?.planOperation) {
      @case ('RENEW') {
        <app-plan-upgrade-renew-paid class="h-auto flex" [invoice]="invoice"></app-plan-upgrade-renew-paid>
      }
      @default {
        <app-plan-upgrade-paid class="w-full" [invoice]="invoice"></app-plan-upgrade-paid>
      }
    }
  } @else {
    <app-plan-upgrade-awaiting-payment [invoice]="invoice"></app-plan-upgrade-awaiting-payment>
  }
} @else {
  <div class="flex justify-center items-center h-full m-auto">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
}
